export function isChinaDomain() {
  return location.host.endsWith('.cn') || location.host.endsWith('cn:3000');
}
